<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '../../../lib/utils'

/**
 * Titled like `ZhSectionHeading`: Space Grotesk rather than Anton (BG §19.1 is a display face that does
 * not survive being shrunk into a dense card), bold, uppercased and system-tracked.
 */
const props = defineProps<{
    class?: HTMLAttributes['class']
}>()
</script>

<template>
  <h3
    data-slot="card-title"
    :class="cn('font-body text-[0.8125rem] leading-snug font-bold uppercase tracking-[var(--tracking-system)]', props.class)"
  >
    <slot />
  </h3>
</template>
